import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

interface FormHeaderProps {
  title: string;
  subtitle: string;
}

const FormHeader: React.FC<FormHeaderProps> = ({ title, subtitle }) => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box ml={smScreen ? 0 : 8} mt={6} mb={2}>
      <Typography
        fontFamily="Lufga"
        fontWeight="500"
        fontSize={smScreen ? '24px' : '32px'}
        color="var(--primary-blue)"
      >
        {title}
      </Typography>

      <Typography
        fontFamily="Nunito Sans"
        fontWeight="400"
        fontSize="14px"
        color="var(--instructions)"
        mt={4}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default FormHeader;
